module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZBAMAAAA2x5hQAAAAMFBMVEUAAADz8e/39vX8/Pz19PH39vT6+fj18/D5+Pe52P/B3f/9/Pzc6/9Emf/+/v6w0/8VTLyZAAAACXRSTlMAPNv+nM72h+9QAF9mAAAAn0lEQVR4Xn2QXQpBURSF15EBGIEyAWUCUt7Fi0cZgW55l4H4GQkzYAC0JST5WTO4OD/3ntpX+d6+TmufvRcspk9eewiYOh21YG0+l58Zzy0nZd7FsuPFWechnj1bgGmuJLBuACVKxuEEVH0qJCsYvCSHXYw20bZDcB5tcQTTaO+/pnNq5lT/p3dRexZvwCTel/zcjnHWS1LsLO/z5vv8AsbX1zVWH12CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/macro_online.png
// module id = EIiz
// module chunks = 6